import type { MouseEvent, ReactNode } from "react";
import { styled } from "styled-components";

import { LatestViewInnerContent } from "domains/knowledgeData/components/SharedComponents";
import type { KnowledgeType, Source } from "entities/knowledge/types";

const StyledKnowledgeDataItemLatestView = styled.a`
  color: ${({ theme }) => theme.colors.textBright};
  display: flex;
  flex-direction: column;
  text-decoration: none;
`;

type KnowledgeDataItemLatestViewProps = {
  articleAnnouncement?: ReactNode;
  title: string;
  imageUrl?: string;
  knowledgeType: KnowledgeType;
  source: Source;
  timestamp?: number;
  link?: string;
  onClick: (event: MouseEvent) => void;
};

export const KnowledgeDataItemLatestView = ({
  title,
  imageUrl,
  knowledgeType,
  source,
  timestamp,
  link,
  onClick,
  articleAnnouncement,
}: KnowledgeDataItemLatestViewProps) => (
  <StyledKnowledgeDataItemLatestView href="#" onClick={onClick}>
    <LatestViewInnerContent
      title={title}
      imageUrl={imageUrl}
      knowledgeType={knowledgeType}
      source={source}
      timestamp={timestamp}
      link={link}
      articleAnnouncement={articleAnnouncement}
    />
  </StyledKnowledgeDataItemLatestView>
);
